export const FIND_EVAL_YEARS_SUCCESS = 'FIND_EVAL_YEARS_SUCCESS';

export const findEvalYearsSuccess = ({ evalYears }) => ({
    type: FIND_EVAL_YEARS_SUCCESS,
    payload: { evalYears },

});
